import React from 'react';
import { Submission } from 'types/evaluation';

interface TabNavigationProps {
  submission: Submission;
  submissionId: string;
  currentTab: string;
  handleTabSwitch: (
    submissionId: string,
    tab: string,
    e: React.MouseEvent
  ) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  submission,
  submissionId,
  currentTab,
  handleTabSwitch,
}) => {
  return (
    <div className="bg-gray-50 border-b border-gray-200 p-4">
      <h3 className="text-lg font-baijamjuree font-bold text-gray-900 mb-3">
        Review Materials
      </h3>
      <nav className="flex space-x-2">
        <button
          onClick={e => handleTabSwitch(submissionId, 'info', e)}
          className={`flex items-center gap-2 px-6 py-3 text-sm font-semibold font-baijamjuree transition-all duration-200 rounded-lg ${
            currentTab === 'info'
              ? 'bg-black text-white shadow-lg'
              : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'
          }`}
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          Submission Info
        </button>
        {submission.award_material && (
          <button
            onClick={e => handleTabSwitch(submissionId, 'presentation', e)}
            className={`flex items-center gap-2 px-6 py-3 text-sm font-semibold font-baijamjuree transition-all duration-200 rounded-lg ${
              currentTab === 'presentation'
                ? 'bg-black text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'
            }`}
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
              />
            </svg>
            Presentation
          </button>
        )}
        {submission.video_url && (
          <button
            onClick={e => handleTabSwitch(submissionId, 'video', e)}
            className={`flex items-center gap-2 px-6 py-3 text-sm font-semibold font-baijamjuree transition-all duration-200 rounded-lg ${
              currentTab === 'video'
                ? 'bg-black text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'
            }`}
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
              />
            </svg>
            Video
          </button>
        )}
      </nav>
    </div>
  );
};

export default TabNavigation;
